import DOMPurify from 'dompurify'

import { Address0 } from '~types'

export const stripHtmlTags = (html: string): string => {
  if (!html) return ''

  // Remove HTML tags
  let text = html.replace(/<[^>]*>/g, '')

  // Replace HTML entities
  text = text
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')

  // Preserve line breaks and paragraphs
  text = text
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<p>/gi, '')

  // Remove extra whitespace
  text = text.replace(/\s+/g, ' ').trim()

  return text
}

export const sanitizeText = (text: string): string => {
  return `<div class="styled-links">${DOMPurify.sanitize(text, {
    ADD_ATTR: ['target', 'rel'],
  })}</div>`
}

export const toTitleCase = (str: string): string => {
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export function oneLineAddress(address: Address0): string {
  const streetWithApt = address.apartment
    ? `${address.street}, ${address.apartment}`
    : address.street
  return `${streetWithApt}, ${address.city}, ${address.state} ${address.zip}`
}

export function oneLineAddressOrNull(address: Address0 | null): string {
  return address ? oneLineAddress(address) : ''
}
